<template>
  <div>
    <!-- Reset E-mail Not Sent -->
    <div v-if="resetEmailNotSent">
      <div class="logo">
        <h1>Forgot Password?</h1>
      </div>

      <form role="form">
        <p class="text-center m-b-lg">If you have forgotten your password, enter your email address or mobile number below and we will send you a password reset email/sms.</p>

        <div class="form-group-outer">
          <div class="form-group float-label-control form-group-email" :class="{ 'has-error': errors.has('email') }" >
            <label for="">Email/Mobile</label>
            <input
              type="email"
              class="form-control"
              placeholder="Email/Mobile"
              name="email"
              v-model="email"
              v-validate="'required'"
              v-float-label>
          </div>
        </div>

        <div class="text-right">
          <ladda-button :on-click="handleSendPasswordEmail" type="success" button-type="submit">Reset Password</ladda-button>
        </div>
      </form>
    </div>

    <!-- Reset E-mail Has Been Sent -->
    <div v-else>
      <div class="logo">
        <h1 v-if="type === 'mobile'">Check Your Phone</h1>
        <h1 v-else>Check Your Email</h1>
      </div>

      <div class="login-content">
        <div class="swal2-show">
          <div class="swal2-icon swal2-success swal2-animate-success-icon" style="display: block;">
            <div class="swal2-success-circular-line-left" style="background: rgb(255, 255, 255);"></div>
            <span class="swal2-success-line-tip swal2-animate-success-line-tip"></span>
            <span class="swal2-success-line-long swal2-animate-success-line-long"></span>
            <div class="swal2-success-ring"></div>
            <div class="swal2-success-fix" style="background: rgb(255, 255, 255);"></div>
            <div class="swal2-success-circular-line-right" style="background: rgb(255, 255, 255);"></div>
          </div>
        </div>

        <div class="margin-20"></div>

        <p class="lead" v-if="type === 'mobile'">A message has been sent with instructions on resetting your password.</p>
        <p class="lead" v-else>An email has been sent with instructions on resetting your password.</p>
      </div>
    </div>

    <div class="login-footer">
      <div class="row">
        <div class="col-xs-7">
          <router-link :to="{ name: 'auth.login' }"><i class="fa fa-angle-left"></i> Back to Login</router-link>
        </div>
        <div class="col-xs-5 text-right">
          <router-link :to="{ name: 'auth.register' }">Register</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { LaddaButton } from 'components/forms'
  import { mapActions } from 'vuex'
  import { first } from 'lodash'

  export default {
    components: {
      LaddaButton
    },

    data () {
      return {
        email: null,
        resetEmailSent: false,
        type: 'email'
      }
    },

    computed: {
      resetEmailNotSent () {
        return !this.resetEmailSent
      }
    },

    methods: {
      ...mapActions('user', ['sendPasswordEmail']),

      /**
       * Handle the sending of a password reset e-mail.
       *
       * @return Promise
       */
      handleSendPasswordEmail () {
        return this.validateAll().then(() => {
          const setResetEmailFlag = () => {
            this.resetEmailSent = true
          }

          return this.sendPasswordEmail(this.email)
            .then(response => {
              this.type = response.data.type
              return response
            })
            .then(setResetEmailFlag)
            .catch(({ response }) => {
              if (response.status === 422) {
                this.errors.add('email', first(response.data.errors.email))
              }
            })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// EmailForm.vue?58bc9c69